import React from 'react';

import FilterSearchCard from 'components/Filter/FilterSearchCard';

interface IOfferTableFiltersProps {
  offerLabel: string;
  externalIdFilter: string;
  onExternalIdFilterChange: (value: string) => void;
  nameFilter: string;
  onNameFilterChange: (value: string) => void;
}

export const OfferTableFilters = ({
  offerLabel,
  externalIdFilter,
  onExternalIdFilterChange,
  nameFilter,
  onNameFilterChange
}: IOfferTableFiltersProps): React.ReactElement => {
  return (
    <div className="flex px-7 gap-3 mb-5">
      <FilterSearchCard
        header={`${offerLabel} External ID`}
        filterValue={externalIdFilter}
        setFilterValue={onExternalIdFilterChange}
        isLabelSearchBy
      />
      <FilterSearchCard
        header={`${offerLabel} Name`}
        filterValue={nameFilter}
        setFilterValue={onNameFilterChange}
      />
    </div>
  );
};
